import React, {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import TabTableMultipleSelection from '../TabTableMultipleSelection';


const MultipleSelectionBar = ({
  actions = [],
  onCancel,
  selectedRowKeys = {},
}) => {
  const [t] = useTranslation('main');

  const { count, hasSelected } = useMemo(() => {
    let count = 0;
    if (Array.isArray(selectedRowKeys)) {
      count = selectedRowKeys.length;
    } else if (selectedRowKeys && typeof selectedRowKeys === 'object') {
      const item = Object.keys(selectedRowKeys).find(
        key => Array.isArray(selectedRowKeys[key]) && selectedRowKeys[key].length > 0
      );
      count = item ? selectedRowKeys[item].length : 0;
    }
    return { count, hasSelected: count > 0 };
  }, [selectedRowKeys]);

  const handleOnCancel = () => {
    let selectedRows;
    if (Array.isArray(selectedRowKeys)) {
      selectedRows = Object.keys(selectedRowKeys).reduce((acc, key) => {
        acc[key] = [];
        return acc;
      }, {});
    } else {
      selectedRows = [];
    }
    onCancel?.(selectedRows);
  }

  return hasSelected ? (
    <TabTableMultipleSelection
      actions={[
        ...actions,
        {onClick: handleOnCancel, label: t('cancel')}
      ]}
      count={count}
      onCancel={handleOnCancel}
    />
  ) : '';
};

export default MultipleSelectionBar;
